import React, { type JSX } from "react";
import { twMerge } from "tailwind-merge";

import { SupText as Text } from "../../../components/UI/Text";
import type { CommonColors } from "../../../types/colors";

interface StatusProps {
  className?: string;
  label: string;
  icon?: JSX.Element | string;
  variant?: "pre" | "post";
  color?: CommonColors;
}

const VARIANTS = {
  pre: {
    primary: "text-neutral-900 border-current bg-neutral-50",
    info: "text-info-500 border-current bg-neutral-50",
    warning: "text-warning-600 border-current bg-neutral-50",
    error: "text-error-700 border-current bg-neutral-50",
    success: "text-success-600 border-current bg-neutral-50",
  },
  post: {
    primary: "bg-neutral-600 border-neutral-600 text-neutral-50",
    info: "bg-info-500 border-info-500 text-neutral-600",
    warning: "bg-warning-600 border-warning-600 text-neutral-50",
    error: "bg-error-700 border-error-700 text-neutral-50",
    success: "bg-success-600 border-success-600 text-neutral-50",
  },
} as const;

export function SupStatusIndicator({ className, label, icon, variant = "pre", color = "primary" }: StatusProps) {
  return (
    <span className={twMerge("sup-status inline-flex rounded-full border-0.5", VARIANTS[variant][color], className)}>
      <Text as="span" variant="caption" className="!leading-5 mx-2">
        {label}
      </Text>
      {icon && <span className="inline-flex h-5 w-5 rounded-full overflow-hidden">{typeof icon === "string" ? <img src={icon} className="object-cover" /> : icon}</span>}
    </span>
  );
}
